<template class="chart">
  <div class="card mt-6" style="clear: both">
    <p class="title is-5 is-pulled-left mt-7 ml-7">Opens</p>
    <b-table class="is-middle" :loading="opens.loading" :data="opens.data" :current-page="opens.current_page"
      :per-page="opens.per_page" :total="opens.total" :opened-detailed="defaultOpenedDetails" detailed detail-key="id"
      :show-detail-icon="showDetailIcon" paginated backend-pagination pagination-position="bottom"
      @page-change="page => opens.changePage(page)">
      <template slot-scope="props">
        <b-table-column label="Device and Users">
          <router-link :to="'/devices/' + props.row.device.id">
            <div>{{ props.row.device.model }}</div>
          </router-link>
          <router-link v-if="props.row.user_id" :to="'/users/' + props.row.user.id">
            <small class="has-text-grey">{{ props.row.user.name }} ({{ props.row.user.email }})</small>
          </router-link>
        </b-table-column>

        <b-table-column label="Magazine">
          <router-link :to="`/magazine/magazines/${props.row.magazine_id}/edit`" class="has-text-grey mr-2">{{
          props.row.magazine.name }} /
          </router-link>

          <router-link :to="`/magazine/magazine/issues/${props.row.id}/edit`" class="has-text-dark" size="is-large">{{
          props.row.issue.title }}
          </router-link>
        </b-table-column>

        <b-table-column label="Reading progress" centered>
          <b-progress :type="typeChange((props.row.read_pages_count / props.row.issue.total_pages) * 100)"
            :value="(props.row.read_pages_count / props.row.issue.total_pages) * 100" show-value>
            {{ (props.row.read_pages_count + "/" + props.row.issue.total_pages) }}
          </b-progress>
        </b-table-column>

        <b-table-column label="Country" centered>
          <flag-img :country="props.row.device.ip_based_country_code"></flag-img>
        </b-table-column>

        <b-table-column label="Opened at" centered>
          <b-tooltip :label="props.row.created_at | dateTime ">
            <span class="has-text-grey">
              {{ props.row.created_at | date }}
            </span>
          </b-tooltip>
        </b-table-column>
      </template>
      <template slot="empty">
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>
              <b-icon icon="emoticon-sad" size="is-large"></b-icon>
            </p>
            <p>No view list.</p>
          </div>
        </section>
      </template>
      <PageReadDetail class="detail" slot="detail" slot-scope="props" :data-id="props.row.issue.id"
        :user-id="props.row.user.id"></PageReadDetail>
    </b-table>
  </div>
</template>

<script>

import PageReadDetail from "@/modules/admin/pages/magazine/magazines/issues/component/PageReadDetail";

export default {
  components: {
    PageReadDetail
  },

  data() {
    return {
      opens: new window.PaginatedRemoteCollection(
        `/admin/api/wifi/${this.$route.params.id}/opens`
      ).load(),
      defaultOpenedDetails: [0],
      showDetailIcon: true
    };
  },

  methods: {
    typeChange(per) {
      if (per < 33.3) {
        return "is-danger";
      }

      if (per < 66.6) {
        return "is-warning"
      }

      if (per <= 100) {
        return "is-success"
      }
    }
  }
};
</script>
